import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { LocalProfileProvider } from "./local/useLocalProfile";
import "./design.css";
import "./styles.css";
import "./game/game.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LocalProfileProvider>
        <App />
      </LocalProfileProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
